import InsertionImagePreview from "./InsertionImagePreview";
import ConfirmationPopover from "./ConfirmationPopover";
import ImageCroppingContainer from "./ImageCroppingContainer";
import ExpansionPreview from "./ExpansionPreview";
import O from "./O";
import ImageInsertionChannelMatching from "./ImageInsertionChannelMatching";
import ImageInsertionFilesystem from "./ImageInsertionFilesystem";
import A from './ActionCreators';
import Id from './IdFactory';
import { useState, useRef } from 'react';
import G from './Getters';
import { useStore, useDispatch } from 'react-redux';
import { produce } from 'immer';
import useElementDims from "./useElementDims";


function assignImageInfoToMatchingChannel({draft,colors,imageId,imageSetId}){
  draft.forEach((channelInfo,iiChannels) => {

    let channelSlotColors = new Set(channelInfo.channelGroup.colors);

    let eqSize = colors.length === channelSlotColors.size;


    let setEq = eqSize && colors.every(col => channelSlotColors.has(col));

    if(setEq){
      draft[iiChannels].imageId = imageId;
      draft[iiChannels].imageSetId = imageSetId;
    }
  })

}

function getAllAtnIds(state,templateEvals){

  let allImageSetIds = new Set(templateEvals.map(x => x.imageSetId).filter(x => x));
  let allAtns = Array.from(allImageSetIds).map(isId => {
    if( !isId ){
      debugger;
    }
    return G.getAnnotationsByImageSetId(state,isId)
  }).flat();
  let atns = allAtns;

  return atns;
}


function getInitialFoucsedFsItemList(initialState,templateEvals){

  let { focusedFsItemList } = initialState || {};
  if( focusedFsItemList ){
    return focusedFsItemList;
  }



}


export default function InsertionChannelScene({
  cellData,
  setRegionAssignments,
  regionAssignments,
  cellLocation,

  nextButton,

  template,
  templateDispatch,

  templateEvals,

  setTemplateEvals,


  imageSetId,
  setImageSetIdToInsert,
  onEvent,

  imageInfoByChannelId,
  setImageInfoByChannelId,

  initialState={},

}){


  const [ previewContent, setPreviewContent ] = useState();
  const dispatch = useDispatch();

  const store = useStore();
  const state = store.getState();



  const [ focusedFsItemIds, setFocusedFsItemIds ] = useState((initialState.focusedFsItemList||[]).map(x => x._id));
  const [ focusedFsItemList, setFocusedFsItemList ] = useState(initialState.focusedFsItemList||[]);
  const [ dialog, setDialog ] = useState();


  const [ itemToView, setItemToView ] = useState();

  const [imagePreviewContainer, setImagePreviewContainer] = useState(null);
  const ipcDims = useElementDims({state: imagePreviewContainer});

  let restrictEpcHeight = null;

  if (imagePreviewContainer != null && ipcDims != null) {
    let ipc = imagePreviewContainer;
    let modalEl = ipc.closest('[role="presentation"]');
    if (modalEl == null) { // This shouldn't trigger, but check anyway
      // Best guess
      restrictEpcHeight = ipcDims.height;
    } else {
      let modalBounds = modalEl.getBoundingClientRect();
      restrictEpcHeight = (modalBounds.y + modalBounds.height) - ipcDims.y;
      console.log('$modalBounds', modalBounds, ipcDims);
    }
  }
  console.log('$reh', restrictEpcHeight);

  

  let [ focusedFsItem ] = focusedFsItemList;

  let focusedImageId;



  //let focusedImageSet;
  if( focusedFsItem ){

    switch( focusedFsItem.type ){
      case "imageUploads":{

        focusedImageId = focusedFsItem._id;
        //focusedImageSet = G.getImageSetByImageId(state,focusedImageId);

        break;
      }
      case "imageSets":{
        /*
        focusedImageSet = G.getImageSet(state,focusedFsItem._id);

        let { images } = focusedImageSet;
        focusedImageId = images[0];
        */
        break;
      }
      default:{
        break;
        throw Error("Selected item type not handlable by 'InsertionChannelScene.js'");
      }
    }
  }



  let usedImageIds = (templateEvals.map(x => x.imageSetId).filter(x => x));

  const onImageMatchingEvent = (event) => {


    if( event.type === "addChannel" ){

      let { action } = event;
      let ev = event.event;

      /*
       If you want to do this AFTER
       things are already set...
       i.e, making changes to channels
       we should CONFIRM, becuase
       the simplest thing would be
       to only allow this to happen
       when there's only THAT thing to change...

       Otherwise we need to fix everything else
       or make everything else look good.


*/

      let { clientX, clientY } = ev;


      setDialog({
        event,
        x:clientX,
        y:clientY,
        type:"Confirm",
      })


      if( action === "single" ){

      }else if( action === "merge" ){

      }

      return;

    }else if( event.type === "view" ){

      let { channelGroup } = event;


      setPreviewContent({
        channelGroup
      });


      if( event.imageId ){

        setItemToView(event.itemToView);
        setFocusedFsItemIds([event.imageId]);
        setFocusedFsItemList([{type:"imageUploads",_id:event.imageId}]);


      }else{
        let { layers } = event;
      }

      return;

    }else if( event.type === "channelGroupChange" ){

      let { channelId, change, e } = event;


      return;
    }else if( event.type === "nodeOrderChange" ){

      let { toMoveIndex, direction } = event;

      let newCompact = produce(template.compact,draft => {
        let channelGroupStructure = draft.channelGroupStructure;

        let str = JSON.stringify(channelGroupStructure);

        let flatNodes = channelGroupStructure.flat();
        let toMoveId = flatNodes[toMoveIndex];
        let newNodeId = flatNodes[toMoveIndex + ({up:-1,down:1}[direction])]

        let newStr = str.replaceAll(toMoveId,'_').replaceAll(newNodeId,toMoveId).replaceAll('_',newNodeId);

        let newStructure = JSON.parse(newStr);




        draft.channelGroupStructure = newStructure;

        /*
        if( newNodeId ){

          let newNodeCurrent = draft.channels[newNodeId];
          let toMoveNode = draft.channels[ toMove ];

          draft.channels[toMove] = newNodeCurrent;
          draft.channels[newNodeId] = toMoveNode;

        }*/

      })

      templateDispatch(newCompact);

      return;



    }else if( event.type === "templateChange" ){

      templateDispatch(event.properties);

      return;

    }


    if( imageSetId ){
      if(event.type === "cancel"){
        setDialog();
        return;
      }else if( event.type === "confirm" ){
        event = dialog.event;
        setDialog();
      }else{
        let mouseEvent = event.event;
        let { clientX, clientY } = mouseEvent;
        setDialog({event, x:clientX, y:clientY})
        return;
      }
    }

    if( event.type === "removeChannel" ){

      let { imageId, channelIndex } = event;
      setFocusedFsItemIds(old => old.filter(x => x!==imageId))
      setTemplateEvals( produce(templateEvals,draft => {
        delete draft[channelIndex].imageId;
      }) )

      /*
        dispatch(A.moveImagesToImageSet({
          imageIds:[imageId],
          destinationImageSetId:Id()
        }))
        */

    }else if( event.type === "focusOnChannel" ){

      let { imageSetId } = template.channels[ event.channelIndex ];
      if( imageSetId ){
        setFocusedFsItemIds([imageSetId]);
        setFocusedFsItemList([{type:"imageSets",_id:imageSetId}]);

      }

    }else if( event.type === "setChannel" ){

      let { channelIndex } =  event;

      let newChannels = produce(templateEvals,draft => {
        draft.forEach((channel,ii) => {

          let theChannelIsSetToTheImageWereSetting = (
            channel.imageId === focusedImageId 
          )

          if( channelIndex === ii ){


            channel.imageId = focusedImageId;

            channel.imageSetId = G.getImageSetIdByImageId(state,focusedImageId);

          }else if( theChannelIsSetToTheImageWereSetting ){
            channel.imageId = null;
          }

        })
        draft[channelIndex].imageId = focusedImageId;




      })
      setTemplateEvals( newChannels )  


      if( !Object.values(regionAssignments).find(x => x) ){


        let newImageSetId = newChannels[channelIndex].imageSetId
        let fullImageAtnId = `v_t=atn;geo=full;is=${newImageSetId}`

        setRegionAssignments({
          ...regionAssignments,
          main:fullImageAtnId,
        })
      }

      if( !newChannels.find(x => x.imageId) ){
        setRegionAssignments(Object.fromEntries(Object.entries(([key,val]) => {
          return [key,null]
        })))
      }
      return;


    } else if( event.type === "setChannel" ){

      let { channelId } =  event;




      let newTemplateEvals = produce(templateEvals,draft => {
        let curImageIdSpot = draft.findIndex(it => it.imageId === focusedImageId);
        if( curImageIdSpot >= 0 ){
          delete draft[curImageIdSpot].imageId;
        }
        draft[event.channelIndex].imageId = focusedImageId;
      })


      setTemplateEvals(newTemplateEvals);
      /*

      let newImageInfo = Object.fromEntries(
        Object.entries(imageInfoByChannelId).map(([key,val]) => {
          if( val.imageId === focusedImageId ){
            return [key,{}]
          }else{
            return [key,val]
          }
      }))


      let imageSetId = G.getImageSetIdByImageId(state,focusedImageId)
      newImageInfo[channelId] = {
        imageId:focusedImageId,
        imageSetId,
      }


      setImageInfoByChannelId(newImageInfo);
      */



      //setTemplateEvals( newChannels )  


      let imageSetId = G.getImageSetIdByImageId(state,focusedImageId)

      if( !Object.values(regionAssignments).find(x => x) ){
        //let newImageSetId = newChannels[channelIndex].imageSetId
        let fullImageAtnId = `v_t=atn;geo=full;is=${imageSetId}`

        let assignments = {
          ...regionAssignments,
          main:fullImageAtnId,
        }
        setRegionAssignments(assignments)
      }else{
      }


      /*
      if( !newChannels.find(x => x.imageId) ){
        setRegionAssignments(Object.fromEntries(Object.entries(([key,val]) => {
          return [key,null]
        })))
      }*/
      return;


    }else if( event.type ==="removeChannel" ){

      let { channelIndex } =  event;
      setTemplateEvals( produce(templateEvals,draft => {
        draft[channelIndex].imageId = null;
      }) ) 

      return;

      //remove from used images...
      //but everything just grouped into channels I think...

    }else{

      debugger;
      throw Error(`Bad event: ${JSON.stringify(event.type)}.`);
    }

    return;


    let { channelIndex } = event;
    let imageIds;
    let [fsItem] = focusedFsItemIds;
    let fsIs;

    if( imageSetId ){

      let state = store.getState();
      fsIs = G.getImageSet(state,fsItem);
      imageIds = fsIs.images;

      dispatch(A.moveImagesToImageSet({
        imageIds,
        destinationImageSetId:(imageSetId||Id()),
      }))


    }else{

      setImageSetIdToInsert(fsItem);
      let fullImageAtnId = `v_t=atn;geo=full;is=${fsItem}`
      //setFocusedAnnotationId(fullImageAtnId);

    }

    let { colors } = event;
    dispatch(A.setImageChannelInfo({
      imageId:focusedImageId,
      channelInfo:{ colors }
    }))

    setTemplateEvals((channelInfo) => {
      return channelInfo.map((ci,ii) => {
        if( ii === channelIndex ){
          return {...ci,imageId:focusedImageId}
        }else{
          return ci;
        }
      })
    })

  }


  let filesystem = (

    <div style={{
      flexBasis:'0 0 250px',
      minWidth:250,
      overflowY:'scroll',
    }} class="full-height rel">
      <ImageInsertionFilesystem {...{
        usedImageIds,
          imageSetIdToInsert:imageSetId,
          focusedFsItemIds,
          focusedFsItemList,
          onFilesystemItemEvent:({
            _id,
            item,
            event,
            treePath
          }) => {

            if( item.type === "imageUploads" ){
              onImageMatchingEvent({
                type:"view",
                imageId:_id
              })
            }else if( item.type === "imageSets" ){
              let { images } = G.getImageSet(
              store.getState(),
                _id
            );

              if( images.length === 1 ){

                onImageMatchingEvent({
                  type:"view",
                  imageId:images[0]
                })
                /*
              setFocusedFsItemIds([images[0]])
              setFocusedFsItemList([{
                _id:images[0],
                type:"imageUploads"
              }])
              */
              }


            }



          }
      }}/>
    </div>
  )



  let toolbar = [ "space", "line", "imageAdjustments" ]


  //throw Error("virtImageId in InsertionChannelScene.js is being used...");


  /*
  let channelsWithImages = templateEvals.filter(x => x.imageId);
  let imageIds = channelsWithImages.map(x => x.imageId);
  let proj = channelsWithImages.map(x => x.channelGroup.colors[0]);
  let virtImageId = `v_t=iu;merge=${imageIds.join(',')};proj=${proj.join(',')}`;
  */



  let atnIdList = getAllAtnIds(state,templateEvals);

  const width = 300;

  let layoutColumn = (

    <div container={"channel-assignment-column"} style={{

      width,
      minWidth:width,
      minHeight:0,
      overflowY:'hidden',





    }} class="sg-col full-height rel">



      <div style={{
        marginTop:8,
        marginRight:8,

        textAlign:'right',
      }}>
        {nextButton}
      </div>



      <ImageInsertionChannelMatching 
        templateEvals={templateEvals}
        template={template}
        accept={!!focusedFsItemList?.[0]}
        onEvent={onImageMatchingEvent}
        focusedImageId={focusedImageId}
      />

      <div style={{
        minHeight:0,
        //maxHeight:'50%', 
        paddingTop:20,
        borderTop:'1px solid #ccc',
        overflow:'hidden',
      }} class="flex-expand rel">

        <div container={"expansion-preview"} style={{
          maxHeight: '100%', 
          minHeight:0,
          height:'100%',
          overflow:'hidden',
        }}>
          {true && (
            <ExpansionPreview {...{
              atnIdList,
                templateEvals,
                cellData,
                cellLocation,
                template,
                imageSetId,
                setRegionAssignments,
                regionAssignments,
                containerWidth:width,
                containerHeight: restrictEpcHeight,
                onEvent:onImageMatchingEvent,
                setImagePreviewContainer,
            }}/>
          )}
        </div>
      </div>
    </div>

  )




  return (

    

      <div style={{
        borderTop:'1px solid #ccc',
        minHeight:0,
      }} class="flex-expand rel full-height"> 

        <div style={{
          minHeight:0,
          minWidth:0,
        }} class="sg-row full-height rel">

          {dialog && <ConfirmationPopover {...{
            dialog,onEvent:onImageMatchingEvent
          }}/>}
          {filesystem}
          <div class="h-divider"/>
          {layoutColumn}
          <div class="h-divider"/>
          <div class="flex-expand rel" style={{
            minWidth:0,
            fontSize:10,
            minHeight:0,
            maxHeight:'100%',
          }}>
            <InsertionImagePreview {...{
              previewContent,
                focusedImageId,
                itemToView,
                atnIdList,
                onEvent,
                toolbar,
                nextButton,
            }}/>
          </div>
          {false && <div class="small-margin">
            {nextButton}
          </div>}
        </div>

      </div>

  )
}
